export const TrackingService = new (class {
    reportLogin(userId: string, userRole: 'admin' | 'user') {
        window.dataLayer.push({
            event: 'login',
            userId,
            userRole,
        })
    }

    reportOpenSubscriptionPricingTable(network: string) {
        window.dataLayer.push({
            event: 'subscriptionOpenPricingTable',
            network
        })
    }

    reportOpenTokenPricingTable() {
        window.dataLayer.push({
            event: 'tokenOpenPricingTable'
        })
    }

    reportSubscriptionPurchase(amount: string, currency: string, transactionId: string) {
        window.dataLayer.push({
            event: 'subscriptionPurchase',
            subscriptionCurrency: currency,
            subscriptionTransactionId: transactionId,
            subscriptionTotalValue: amount
        })
    }

    reportTokenPurchase(amount: string, currency: string, transactionId: string) {
        window.dataLayer.push({
            event: 'tokenPurchase',
            tokenCurrency: currency,
            tokenTransactionId: transactionId,
            tokenTotalValue: amount
        })
    }
})()
